import { reactive } from 'cdui-js';
import { CheckBox } from '../../components/CheckBox';
import { lastProgress, nextProgress } from './store';
import { showToast } from '../../components/Toast';
import { PhoneLink } from '../../../../components/PhoneLink';
import i18n from '../../../../i18n';
import { addAccountBarPadBottom, addAccountContentReserve } from './safeAreaBar';

const Risk = () => {
  const state = reactive({ agreed: false });
  // 已阅读勾选 DOM 引用：校验失败时滚动到未勾选项
  let agreeRef: HTMLDivElement | null = null;

  return (
    <div>
      {/* ── 滚动内容区 ── */}
      <div class="padding-x-L padding-y" style={{ 'margin-bottom': `${addAccountContentReserve(140)}px` }}>
        {/* 提示标题 */}
        <div class="flex align-center margin-b" style={{ gap: '4px' }}>
          <span class="color-D">{i18n.AddAccount.RiskReadHint}</span>
        </div>

        {/* 风险披露内容区 */}
        <div
          class="round"
          style={{
            background: 'var(--bg-muted)',
            padding: '16px',
            'margin-bottom': '12px',
            'min-height': '460px',
          }}
        >
          <p class="color-D" style={{ 'font-size': '13px', 'line-height': '1.75', margin: '0 0 12px' }}>
            <strong>{i18n.AddAccount.RiskTitle}</strong>
          </p>
          <p class="color-D" style={{ 'font-size': '13px', 'line-height': '1.75', margin: '0 0 10px' }}>
            {i18n.AddAccount.RiskIntro}
          </p>
          <p class="color-D" style={{ 'font-size': '13px', 'line-height': '1.75', margin: '0 0 10px' }}>
            <strong>{i18n.AddAccount.RiskSection1}</strong>
            <br />
            {i18n.AddAccount.RiskSection1Body}
          </p>
          <p class="color-D" style={{ 'font-size': '13px', 'line-height': '1.75', margin: '0 0 10px' }}>
            <strong>{i18n.AddAccount.RiskSection2}</strong>
            <br />
            {i18n.AddAccount.RiskSection2Body}
          </p>
          <p class="color-D" style={{ 'font-size': '13px', 'line-height': '1.75', margin: '0 0 10px' }}>
            <strong>{i18n.AddAccount.RiskSection3}</strong>
            <br />
            {i18n.AddAccount.RiskSection3Body}
          </p>
          <p class="color-D" style={{ 'font-size': '13px', 'line-height': '1.75', margin: '0 0 10px' }}>
            <strong>{i18n.AddAccount.RiskSection4}</strong>
            <br />
            {i18n.AddAccount.RiskSection4Body}
          </p>
          <p class="color-D" style={{ 'font-size': '13px', 'line-height': '1.75', margin: '0 0 10px' }}>
            <strong>{i18n.AddAccount.RiskSection5}</strong>
            <br />
            {i18n.AddAccount.RiskSection5Body}
          </p>
          <p class="color-D" style={{ 'font-size': '13px', 'line-height': '1.75', margin: '0' }}>
            {i18n.AddAccount.RiskFooter}
          </p>
        </div>

        {/* 联系方式 */}
        <div style={{ display: 'flex', 'flex-direction': 'column', gap: '4px' }}>
          <span class="font-s-XXS" style={{ color: 'var(--text-3)', 'line-height': '1.4' }}>
            {i18n.AddAccount.RiskHotline} <PhoneLink />
          </span>
          <span class="font-s-XXS" style={{ color: 'var(--text-3)', 'line-height': '1.4' }}>
            {i18n.AddAccount.RiskOnlineService}
          </span>
          <span class="font-s-XXS" style={{ color: 'var(--text-3)', 'line-height': '1.4' }}>
            {i18n.AddAccount.RiskOfficeHours}
          </span>
        </div>
      </div>

      {/* ── 底部固定区域 ── */}
      <div
        class="fixed position-b position-l width-100 bg-c padding-x-L flex flex-column gap-16px"
        style={{
          'padding-top': '12px',
          'padding-bottom': `${addAccountBarPadBottom(16)}px`,
          'z-index': 150,
        }}
      >
        {/* 已阅读勾选 */}
        <div ref={(el) => { agreeRef = el; }} class="flex justify-center">
          <CheckBox type={2} active={state.agreed} change={(v) => (state.agreed = v)}>
            <span class="font-s-S" style={{ color: 'var(--text-2)', 'line-height': '16px' }}>
              {i18n.AddAccount.RiskAgree}
            </span>
          </CheckBox>
        </div>

        <div class="width-100 flex gap-8px">
          <button
            class="default-btn btn-rounded"
            style={{ flex: 1 }}
            onclick={() => {
              lastProgress();
            }}
          >
            {i18n.OpenProgress.Common.Prev}
          </button>
          <button
            class="confirm-btn btn-rounded"
            style={{
              flex: 2,
            }}
            onclick={() => {
              if (!state.agreed) {
                showToast(i18n.AddAccount.ToastAgreeRisk);
                agreeRef?.scrollIntoView({ block: 'center', behavior: 'smooth' });
                return;
              }
              nextProgress();
            }}
          >
            {i18n.OpenProgress.Common.Next}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Risk;
